import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-warning-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './warning-popup.component.html',
  styleUrls: ['./warning-popup.component.scss']
})
export class WarningPopupComponent {
  @Input() isVisible: boolean = false;
  @Input() message: string = '';
  @Input() showBackToDashboard: boolean = true;
  @Output() close = new EventEmitter<void>();

  // Environment configuration
  protected readonly environment = environment;

  onClose(): void {
    this.close.emit();
  }
  get dashboardUrl(): string {
    return this.environment.dashboardUrl;
  }

}
